import { render, staticRenderFns } from "./atsModal.vue?vue&type=template&id=1878edf1&scoped=true"
import script from "./atsModal.vue?vue&type=script&lang=js"
export * from "./atsModal.vue?vue&type=script&lang=js"
import style0 from "./atsModal.vue?vue&type=style&index=0&id=1878edf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1878edf1",
  null
  
)

export default component.exports